<template>
  <v-tabs>
    <v-tab
      v-for="tab in tabs"
      v-bind="tab"
      :key="tab.text"
      class="text-subtitle-1 flex-grow-1 flex-sm-grow-0"
      width="150px"
      replace
    >
      {{ tab.text }}
    </v-tab>
  </v-tabs>
  <v-divider />
</template>

<script setup lang="ts">
import { usePageType } from '~/composables/usePageType'
import { AWARD_ROUTE_NAMES, GRAND_PRIX_ROUTE_NAMES } from '~/features/Home/constants'

const $route = useRoute()
const { isGrandPrixPage } = usePageType()

const year = computed(() => $route.params.year)

const redirectLinksName = computed(() => {
  const routeNames = isGrandPrixPage.value ? GRAND_PRIX_ROUTE_NAMES : AWARD_ROUTE_NAMES

  return {
    doctor: routeNames.doctor,
    lpu: routeNames.lpu,
  }
})

const tabs = computed(() => [
  {
    text: 'Врачи',
    to: {
      name: redirectLinksName.value.doctor,
      params: { year: year.value },
    },
  },
  {
    text: 'Клиники',
    to: {
      name: redirectLinksName.value.lpu,
      params: { year: year.value },
    },
  },
])

</script>
